export default __webpack_public_path__ + "assets/1d848d83f2381b8417e9469f7b1dc370.svg";